import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');
import { BackOfficeInvoiceConfig } from './BackOfficeInvoiceConfig';

export class BackOfficePaymentConfig extends BackOfficeInvoiceConfig {
    _originalTypeClassName = "zERP.BO.BackOfficePaymentConfig";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BackOfficePaymentConfig.translate = translateService;
}
super();
this.LineMappings = [];
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
BankAccount:any;
LineMappings:any;
CashAccount:any;
static setBankAccount = ($this, value) => {
var oldValue = $this.BankAccount;
$this.BankAccount = value;
if (value != null) {
}
}
static setLineMappings = ($this, items) => {
                if (items == null) items = [];
                if ($this.LineMappings == null) $this.LineMappings = [];

                const copyItems = Common.cloneObject(items);

                while ($this.LineMappings.length > 0) {
                    Domain.BackOfficePaymentConfig.removeLineMappings($this, $this.LineMappings[0]);
                }

                Domain.BackOfficePaymentConfig.addManyLineMappings($this, copyItems);
            }
static addManyLineMappings = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BackOfficePaymentConfig.addLineMappings($this, items[i]);
                }
            }
static addLineMappings = ($this, item) => {
                if ($this.LineMappings == null) $this.LineMappings = [];
                if (item == null || $this.LineMappings.indexOf(item) > -1) return;
                $this.LineMappings.push(item);
}
static addRangeLineMappings = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BackOfficePaymentConfig.addLineMappings($this, item));
            }
static removeLineMappings = ($this, item) => {
                if ($this == null || $this.LineMappings == null || $this.LineMappings.indexOf(item) === -1) return;
                var _index = $this.LineMappings.indexOf(item);
                $this.LineMappings.splice(_index, 1);
}
static clearLineMappings = ($this) => { $this.LineMappings = null; }
static setCashAccount = ($this, value) => {
var oldValue = $this.CashAccount;
$this.CashAccount = value;
if (value != null) {
}
}

static GetIssueInvoice($this: any, document: any): any{let issueInvoicePaymentType = $this?.IssueInvoicePaymentTypes?.linq?.where((t) => CLMS.Framework.Number.Equal(() => t.PaymentMethodMapping.BackofficeId, () => document.paymentType))?.firstOrDefault(null);
if (issueInvoicePaymentType == null) {return false;}
return issueInvoicePaymentType?.IssueInvoice;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}